// extracted by mini-css-extract-plugin
module.exports = {"container":"_1Uunh","content":"AB7h6"};